import React from 'react';
import FormSelectCompany from './components';

const SelectCompany = () => {

  return <FormSelectCompany />
}

export default SelectCompany;